import { useCallback, useState } from 'react'
import useEventTracking from '../../../../lib/hooks/tracking'

import { isServer } from '../../../../lib/utils'
import { loginUser } from '../../../../lib/utils/api'
import getDomainFromEmail from '../../../../lib/utils/getDomainFromEmail'
import { DataLayerEvents, DataLayerUserType, DataLayerVariables } from '../../../../lib/context/TrackingContext/interfaces'
import { useParams, useRegistrationContext } from '../../context/registration'
import { useSignupContext } from '../../context/signup'

export const useLogin = () => {
  const [loading, setLoading] = useState(false)
  const { setIsAuthenticated } = useRegistrationContext()
  const { goto } = useRegistrationContext()
  const [error, setError] = useState<string | undefined>(undefined)
  const {
    productName,
  } = useSignupContext()
  const trackEvent = useEventTracking()

  const login = useCallback(
    async (email: string, password: string) => {
      setLoading(true)
      setError(undefined)

      try {
        const response = await loginUser({ email, password })
        const {
          data: { id = 'NA' },
        } = response

        if (response.data && !isServer()) {
          trackEvent('user_logged_in', {
            user_id: id,
            user_email: getDomainFromEmail(email),
            user_type: 'login',
          })
          window.localStorage.setItem('token', response.data.token)
          window.localStorage.setItem('trialProduct', productName)
          setIsAuthenticated(true)
          goto('/downloads')
        }
      } catch (e) {
        setError(e.message)
        setLoading(false)
      }
      setLoading(false)
    },
    [goto, setIsAuthenticated, productName],
  )

  return { loading, login, error }
}
